import "./filter/button.component";
import "./filter/category.component";
import "./filter/daterange.component";
import "./filter/query.component";
import "./media-editor/media-editor.component";
import "./media-gallery/media-gallery.component";
import "./multiple-image/multiple-image.component";
import "./need-help-btn/need-help-btn.component";
import "./premium/premium-btn.component";
import "./print/print-item.service";
import "./select-lang/select-lang.component";
import "./sidenav/sidenav.component";
import "./sort-menu/sort-menu.component";
import "./sort-table-btn/sort-table-btn.component";
import "./topbar/topbar.component";
import "./responsive-navbar/responsive-navbar.component";
import "./back-to-top/back-to-top-button.component";
import "./btn-tooltip/btn-tooltip.component";
import "./overlay-video/overlay-video.component";
import "./translations/select-language.component";
import "./translations/translate-button.component";
import "./translations/translations-toolbar.component";
import "./translations/translations-text-area.component";
import "./translations/translations-input-text.component";
import "./sale-publish/items-publish-summary.component";

angular.module("thor.shared", [
    "thor.shared.filter.button.component",
    "thor.shared.filter.category.component",
    "thor.shared.filter.daterange.component",
    "thor.shared.filter.query.component",
    "thor.shared.media-editor.component",
    "thor.shared.media-gallery.component",
    "thor.shared.multipleImage.component",
    "thor.shared.need-help-btn.component",
    "thor.shared.premium.premium-btn.component",
    "thor.shared.print.item.service",
    "thor.shared.select-lang.component",
    "thor.shared.sidenav.component",
    "thor.shared.sort-menu.component",
    "thor.shared.sort-table-btn.component",
    "thor.shared.topbar.component",
    "thor.shared.responsive-navbar.component",
    "thor.shared.back-to-top-button.component",
    "thor.shared.btn-tooltip.component",
    "thor.shared.overlay-video.component",
    "thor.shared.translations.select-language.component",
    "thor.shared.translations.translate-button.component",
    "thor.shared.translations.translations-toolbar.component",
    "thor.shared.translations.translations-text-area.component",
    "thor.shared.translations.translations-input-text.component",
    "thor.shared.sale-publish.items-publish-summary.component"
]);
